/**
 * Child Support Amounts for 2021
 * 
 * Data exported from [calc].child_support_amount table
 * tax_year_lookup_id: 1 (2021 = 1 + 2020)
 */

import { ChildSupportLevel } from '../../../types';

export const childSupportLevelsIA2021: ChildSupportLevel[] = [
  {
    combinedAdjustedNetIncomeMinimum: 0,
    combinedAdjustedNetIncomeMaximum: 100.99,
    amounts: [30, 50, 50, 50, 50],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 101,
    combinedAdjustedNetIncomeMaximum: 200.99,
    amounts: [30, 50, 50, 50, 50],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 201,
    combinedAdjustedNetIncomeMaximum: 300.99,
    amounts: [31, 50, 50, 55, 60],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 301,
    combinedAdjustedNetIncomeMaximum: 400.99,
    amounts: [42, 58, 66, 73, 80],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 401,
    combinedAdjustedNetIncomeMaximum: 500.99,
    amounts: [52, 72, 82, 91, 100],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 501,
    combinedAdjustedNetIncomeMaximum: 600.99,
    amounts: [62, 87, 99, 109, 120],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 601,
    combinedAdjustedNetIncomeMaximum: 700.99,
    amounts: [73, 101, 115, 128, 140],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 701,
    combinedAdjustedNetIncomeMaximum: 800.99,
    amounts: [83, 116, 132, 146, 160],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 801,
    combinedAdjustedNetIncomeMaximum: 850.99,
    amounts: [88, 123, 140, 155, 170],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 851,
    combinedAdjustedNetIncomeMaximum: 900.99,
    amounts: [94, 130, 148, 164, 180],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 901,
    combinedAdjustedNetIncomeMaximum: 950.99,
    amounts: [99, 138, 156, 173, 190],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 951,
    combinedAdjustedNetIncomeMaximum: 1000.99,
    amounts: [104, 145, 164, 182, 200],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1001,
    combinedAdjustedNetIncomeMaximum: 1050.99,
    amounts: [109, 152, 173, 192, 210],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1051,
    combinedAdjustedNetIncomeMaximum: 1100.99,
    amounts: [114, 159, 181, 201, 220],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1101,
    combinedAdjustedNetIncomeMaximum: 1150.99,
    amounts: [120, 167, 189, 210, 230],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1151,
    combinedAdjustedNetIncomeMaximum: 1200.99,
    amounts: [145, 197, 222, 242, 267],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1201,
    combinedAdjustedNetIncomeMaximum: 1250.99,
    amounts: [170, 227, 254, 275, 305],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1251,
    combinedAdjustedNetIncomeMaximum: 1300.99,
    amounts: [195, 257, 287, 307, 342],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1301,
    combinedAdjustedNetIncomeMaximum: 1350.99,
    amounts: [220, 287, 319, 340, 380],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1351,
    combinedAdjustedNetIncomeMaximum: 1400.99,
    amounts: [245, 317, 352, 372, 417],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1401,
    combinedAdjustedNetIncomeMaximum: 1450.99,
    amounts: [270, 347, 384, 405, 455],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1451,
    combinedAdjustedNetIncomeMaximum: 1500.99,
    amounts: [295, 377, 417, 437, 492],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1501,
    combinedAdjustedNetIncomeMaximum: 1550.99,
    amounts: [320, 407, 449, 470, 530],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1551,
    combinedAdjustedNetIncomeMaximum: 1600.99,
    amounts: [345, 437, 482, 502, 567],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1601,
    combinedAdjustedNetIncomeMaximum: 1650.99,
    amounts: [370, 467, 514, 535, 605],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1651,
    combinedAdjustedNetIncomeMaximum: 1700.99,
    amounts: [395, 497, 547, 567, 642],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1701,
    combinedAdjustedNetIncomeMaximum: 1750.99,
    amounts: [420, 527, 579, 600, 680],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1751,
    combinedAdjustedNetIncomeMaximum: 1800.99,
    amounts: [444, 557, 612, 632, 717],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1801,
    combinedAdjustedNetIncomeMaximum: 1850.99,
    amounts: [456, 587, 644, 665, 755],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1851,
    combinedAdjustedNetIncomeMaximum: 1900.99,
    amounts: [468, 617, 677, 697, 792],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1901,
    combinedAdjustedNetIncomeMaximum: 1950.99,
    amounts: [480, 647, 709, 730, 830],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1951,
    combinedAdjustedNetIncomeMaximum: 2000.99,
    amounts: [492, 677, 742, 762, 867],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2001,
    combinedAdjustedNetIncomeMaximum: 2050.99,
    amounts: [504, 707, 774, 795, 891],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2051,
    combinedAdjustedNetIncomeMaximum: 2100.99,
    amounts: [516, 737, 807, 827, 913],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2101,
    combinedAdjustedNetIncomeMaximum: 2150.99,
    amounts: [528, 765, 839, 860, 935],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2151,
    combinedAdjustedNetIncomeMaximum: 2200.99,
    amounts: [539, 782, 872, 892, 957],
    lowIncomes: [false, false, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2201,
    combinedAdjustedNetIncomeMaximum: 2250.99,
    amounts: [551, 799, 904, 925, 979],
    lowIncomes: [false, false, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2251,
    combinedAdjustedNetIncomeMaximum: 2300.99,
    amounts: [563, 816, 937, 957, 1001],
    lowIncomes: [false, false, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2301,
    combinedAdjustedNetIncomeMaximum: 2350.99,
    amounts: [575, 833, 969, 990, 1023],
    lowIncomes: [false, false, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2351,
    combinedAdjustedNetIncomeMaximum: 2400.99,
    amounts: [587, 850, 1001, 1021, 1045],
    lowIncomes: [false, false, false, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2401,
    combinedAdjustedNetIncomeMaximum: 2450.99,
    amounts: [599, 867, 1021, 1043, 1067],
    lowIncomes: [false, false, false, false, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2451,
    combinedAdjustedNetIncomeMaximum: 2500.99,
    amounts: [611, 885, 1041, 1064, 1089],
    lowIncomes: [false, false, false, false, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2501,
    combinedAdjustedNetIncomeMaximum: 2550.99,
    amounts: [623, 902, 1062, 1086, 1111],
    lowIncomes: [false, false, false, false, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2551,
    combinedAdjustedNetIncomeMaximum: 2600.99,
    amounts: [635, 920, 1083, 1107, 1133],
    lowIncomes: [false, false, false, false, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2601,
    combinedAdjustedNetIncomeMaximum: 2650.99,
    amounts: [647, 937, 1104, 1129, 1155],
    lowIncomes: [false, false, false, false, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2651,
    combinedAdjustedNetIncomeMaximum: 2700.99,
    amounts: [660, 955, 1125, 1150, 1177],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2701,
    combinedAdjustedNetIncomeMaximum: 2750.99,
    amounts: [672, 973, 1146, 1172, 1199],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2751,
    combinedAdjustedNetIncomeMaximum: 2800.99,
    amounts: [684, 990, 1166, 1193, 1221],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2801,
    combinedAdjustedNetIncomeMaximum: 2850.99,
    amounts: [696, 1008, 1187, 1215, 1243],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2851,
    combinedAdjustedNetIncomeMaximum: 2900.99,
    amounts: [708, 1025, 1208, 1236, 1265],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2901,
    combinedAdjustedNetIncomeMaximum: 2950.99,
    amounts: [720, 1043, 1229, 1258, 1287],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2951,
    combinedAdjustedNetIncomeMaximum: 3000.99,
    amounts: [732, 1061, 1250, 1279, 1309],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3001,
    combinedAdjustedNetIncomeMaximum: 3050.99,
    amounts: [744, 1078, 1271, 1301, 1331],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3051,
    combinedAdjustedNetIncomeMaximum: 3100.99,
    amounts: [757, 1096, 1291, 1322, 1353],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3101,
    combinedAdjustedNetIncomeMaximum: 3150.99,
    amounts: [769, 1113, 1312, 1344, 1375],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3151,
    combinedAdjustedNetIncomeMaximum: 3200.99,
    amounts: [781, 1131, 1333, 1365, 1397],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3201,
    combinedAdjustedNetIncomeMaximum: 3250.99,
    amounts: [790, 1144, 1347, 1387, 1419],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3251,
    combinedAdjustedNetIncomeMaximum: 3300.99,
    amounts: [799, 1157, 1361, 1408, 1441],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3301,
    combinedAdjustedNetIncomeMaximum: 3350.99,
    amounts: [809, 1169, 1375, 1430, 1463],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3351,
    combinedAdjustedNetIncomeMaximum: 3400.99,
    amounts: [818, 1182, 1390, 1451, 1485],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3401,
    combinedAdjustedNetIncomeMaximum: 3450.99,
    amounts: [827, 1195, 1404, 1473, 1507],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3451,
    combinedAdjustedNetIncomeMaximum: 3500.99,
    amounts: [837, 1207, 1418, 1494, 1529],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3501,
    combinedAdjustedNetIncomeMaximum: 3550.99,
    amounts: [846, 1220, 1432, 1516, 1551],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3551,
    combinedAdjustedNetIncomeMaximum: 3600.99,
    amounts: [855, 1233, 1446, 1537, 1573],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3601,
    combinedAdjustedNetIncomeMaximum: 3650.99,
    amounts: [865, 1246, 1460, 1559, 1595],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3651,
    combinedAdjustedNetIncomeMaximum: 3700.99,
    amounts: [873, 1257, 1473, 1580, 1617],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3701,
    combinedAdjustedNetIncomeMaximum: 3750.99,
    amounts: [879, 1266, 1484, 1598, 1639],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3751,
    combinedAdjustedNetIncomeMaximum: 3800.99,
    amounts: [884, 1274, 1494, 1616, 1661],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3801,
    combinedAdjustedNetIncomeMaximum: 3850.99,
    amounts: [890, 1283, 1504, 1635, 1683],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3851,
    combinedAdjustedNetIncomeMaximum: 3900.99,
    amounts: [896, 1291, 1514, 1653, 1705],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3901,
    combinedAdjustedNetIncomeMaximum: 3950.99,
    amounts: [901, 1299, 1524, 1671, 1727],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3951,
    combinedAdjustedNetIncomeMaximum: 4000.99,
    amounts: [907, 1308, 1534, 1689, 1749],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4001,
    combinedAdjustedNetIncomeMaximum: 4050.99,
    amounts: [913, 1316, 1545, 1708, 1771],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4051,
    combinedAdjustedNetIncomeMaximum: 4100.99,
    amounts: [918, 1325, 1555, 1726, 1793],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4101,
    combinedAdjustedNetIncomeMaximum: 4150.99,
    amounts: [924, 1333, 1565, 1744, 1815],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4151,
    combinedAdjustedNetIncomeMaximum: 4200.99,
    amounts: [930, 1342, 1575, 1759, 1837],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4201,
    combinedAdjustedNetIncomeMaximum: 4250.99,
    amounts: [936, 1350, 1584, 1770, 1859],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4251,
    combinedAdjustedNetIncomeMaximum: 4300.99,
    amounts: [942, 1359, 1594, 1780, 1881],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4301,
    combinedAdjustedNetIncomeMaximum: 4350.99,
    amounts: [948, 1367, 1604, 1791, 1903],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4351,
    combinedAdjustedNetIncomeMaximum: 4400.99,
    amounts: [954, 1376, 1613, 1802, 1925],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4401,
    combinedAdjustedNetIncomeMaximum: 4450.99,
    amounts: [961, 1384, 1623, 1813, 1947],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4451,
    combinedAdjustedNetIncomeMaximum: 4500.99,
    amounts: [967, 1393, 1632, 1823, 1969],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4501,
    combinedAdjustedNetIncomeMaximum: 4550.99,
    amounts: [973, 1401, 1642, 1834, 1991],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4551,
    combinedAdjustedNetIncomeMaximum: 4600.99,
    amounts: [979, 1410, 1652, 1845, 2013],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4601,
    combinedAdjustedNetIncomeMaximum: 4650.99,
    amounts: [985, 1418, 1661, 1856, 2035],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4651,
    combinedAdjustedNetIncomeMaximum: 4700.99,
    amounts: [989, 1424, 1667, 1862, 2048],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4701,
    combinedAdjustedNetIncomeMaximum: 4750.99,
    amounts: [993, 1428, 1671, 1867, 2053],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4751,
    combinedAdjustedNetIncomeMaximum: 4800.99,
    amounts: [997, 1432, 1675, 1871, 2058],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4801,
    combinedAdjustedNetIncomeMaximum: 4850.99,
    amounts: [1000, 1437, 1679, 1876, 2063],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4851,
    combinedAdjustedNetIncomeMaximum: 4900.99,
    amounts: [1004, 1441, 1683, 1880, 2068],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4901,
    combinedAdjustedNetIncomeMaximum: 4950.99,
    amounts: [1007, 1445, 1687, 1885, 2073],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4951,
    combinedAdjustedNetIncomeMaximum: 5000.99,
    amounts: [1011, 1450, 1691, 1889, 2078],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5001,
    combinedAdjustedNetIncomeMaximum: 5050.99,
    amounts: [1014, 1454, 1695, 1894, 2083],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5051,
    combinedAdjustedNetIncomeMaximum: 5100.99,
    amounts: [1018, 1458, 1699, 1898, 2088],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5101,
    combinedAdjustedNetIncomeMaximum: 5150.99,
    amounts: [1021, 1462, 1703, 1903, 2093],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5151,
    combinedAdjustedNetIncomeMaximum: 5200.99,
    amounts: [1026, 1469, 1710, 1910, 2101],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5201,
    combinedAdjustedNetIncomeMaximum: 5250.99,
    amounts: [1031, 1475, 1718, 1919, 2110],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5251,
    combinedAdjustedNetIncomeMaximum: 5300.99,
    amounts: [1035, 1481, 1725, 1927, 2119],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5301,
    combinedAdjustedNetIncomeMaximum: 5350.99,
    amounts: [1040, 1488, 1732, 1935, 2128],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5351,
    combinedAdjustedNetIncomeMaximum: 5400.99,
    amounts: [1044, 1494, 1739, 1943, 2137],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5401,
    combinedAdjustedNetIncomeMaximum: 5450.99,
    amounts: [1049, 1501, 1747, 1951, 2146],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5451,
    combinedAdjustedNetIncomeMaximum: 5500.99,
    amounts: [1053, 1507, 1754, 1959, 2155],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5501,
    combinedAdjustedNetIncomeMaximum: 5550.99,
    amounts: [1058, 1513, 1761, 1967, 2164],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5551,
    combinedAdjustedNetIncomeMaximum: 5600.99,
    amounts: [1063, 1520, 1768, 1975, 2173],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5601,
    combinedAdjustedNetIncomeMaximum: 5650.99,
    amounts: [1067, 1526, 1776, 1983, 2182],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5651,
    combinedAdjustedNetIncomeMaximum: 5700.99,
    amounts: [1072, 1532, 1783, 1992, 2191],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5701,
    combinedAdjustedNetIncomeMaximum: 5750.99,
    amounts: [1076, 1539, 1790, 2000, 2200],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5751,
    combinedAdjustedNetIncomeMaximum: 5800.99,
    amounts: [1081, 1545, 1797, 2008, 2209],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5801,
    combinedAdjustedNetIncomeMaximum: 5850.99,
    amounts: [1086, 1552, 1805, 2016, 2217],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5851,
    combinedAdjustedNetIncomeMaximum: 5900.99,
    amounts: [1090, 1558, 1812, 2024, 2227],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5901,
    combinedAdjustedNetIncomeMaximum: 5950.99,
    amounts: [1096, 1565, 1820, 2033, 2237],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5951,
    combinedAdjustedNetIncomeMaximum: 6000.99,
    amounts: [1101, 1573, 1828, 2042, 2247],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6001,
    combinedAdjustedNetIncomeMaximum: 6050.99,
    amounts: [1106, 1580, 1836, 2051, 2256],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6051,
    combinedAdjustedNetIncomeMaximum: 6100.99,
    amounts: [1112, 1587, 1845, 2060, 2266],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6101,
    combinedAdjustedNetIncomeMaximum: 6150.99,
    amounts: [1117, 1595, 1853, 2069, 2276],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6151,
    combinedAdjustedNetIncomeMaximum: 6200.99,
    amounts: [1122, 1602, 1861, 2078, 2286],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6201,
    combinedAdjustedNetIncomeMaximum: 6250.99,
    amounts: [1128, 1609, 1869, 2088, 2296],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6251,
    combinedAdjustedNetIncomeMaximum: 6300.99,
    amounts: [1133, 1616, 1877, 2097, 2306],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6301,
    combinedAdjustedNetIncomeMaximum: 6350.99,
    amounts: [1138, 1624, 1885, 2106, 2316],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6351,
    combinedAdjustedNetIncomeMaximum: 6400.99,
    amounts: [1144, 1631, 1893, 2115, 2326],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6401,
    combinedAdjustedNetIncomeMaximum: 6450.99,
    amounts: [1149, 1638, 1901, 2124, 2336],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6451,
    combinedAdjustedNetIncomeMaximum: 6500.99,
    amounts: [1154, 1646, 1909, 2133, 2346],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6501,
    combinedAdjustedNetIncomeMaximum: 6550.99,
    amounts: [1160, 1653, 1917, 2142, 2356],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6551,
    combinedAdjustedNetIncomeMaximum: 6600.99,
    amounts: [1165, 1660, 1926, 2151, 2366],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6601,
    combinedAdjustedNetIncomeMaximum: 6650.99,
    amounts: [1170, 1667, 1934, 2160, 2376],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6651,
    combinedAdjustedNetIncomeMaximum: 6700.99,
    amounts: [1175, 1675, 1942, 2170, 2387],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6701,
    combinedAdjustedNetIncomeMaximum: 6750.99,
    amounts: [1180, 1682, 1951, 2179, 2397],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6751,
    combinedAdjustedNetIncomeMaximum: 6800.99,
    amounts: [1185, 1689, 1959, 2188, 2407],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6801,
    combinedAdjustedNetIncomeMaximum: 6850.99,
    amounts: [1190, 1696, 1968, 2198, 2418],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6851,
    combinedAdjustedNetIncomeMaximum: 6900.99,
    amounts: [1196, 1704, 1976, 2207, 2428],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6901,
    combinedAdjustedNetIncomeMaximum: 6950.99,
    amounts: [1201, 1711, 1985, 2217, 2438],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6951,
    combinedAdjustedNetIncomeMaximum: 7000.99,
    amounts: [1206, 1718, 1993, 2226, 2449],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7001,
    combinedAdjustedNetIncomeMaximum: 7050.99,
    amounts: [1211, 1725, 2002, 2236, 2459],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7051,
    combinedAdjustedNetIncomeMaximum: 7100.99,
    amounts: [1216, 1733, 2010, 2245, 2470],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7101,
    combinedAdjustedNetIncomeMaximum: 7150.99,
    amounts: [1221, 1740, 2018, 2255, 2480],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7151,
    combinedAdjustedNetIncomeMaximum: 7200.99,
    amounts: [1226, 1747, 2027, 2264, 2490],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7201,
    combinedAdjustedNetIncomeMaximum: 7250.99,
    amounts: [1231, 1754, 2035, 2273, 2501],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7251,
    combinedAdjustedNetIncomeMaximum: 7300.99,
    amounts: [1236, 1762, 2044, 2283, 2511],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7301,
    combinedAdjustedNetIncomeMaximum: 7350.99,
    amounts: [1241, 1769, 2052, 2292, 2522],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7351,
    combinedAdjustedNetIncomeMaximum: 7400.99,
    amounts: [1246, 1776, 2060, 2301, 2531],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7401,
    combinedAdjustedNetIncomeMaximum: 7450.99,
    amounts: [1251, 1783, 2068, 2310, 2541],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7451,
    combinedAdjustedNetIncomeMaximum: 7500.99,
    amounts: [1256, 1790, 2076, 2318, 2550],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7501,
    combinedAdjustedNetIncomeMaximum: 7550.99,
    amounts: [1262, 1797, 2083, 2327, 2560],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7551,
    combinedAdjustedNetIncomeMaximum: 7600.99,
    amounts: [1267, 1804, 2091, 2336, 2569],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7601,
    combinedAdjustedNetIncomeMaximum: 7650.99,
    amounts: [1272, 1811, 2099, 2344, 2579],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7651,
    combinedAdjustedNetIncomeMaximum: 7700.99,
    amounts: [1277, 1818, 2107, 2353, 2588],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7701,
    combinedAdjustedNetIncomeMaximum: 7750.99,
    amounts: [1282, 1824, 2114, 2362, 2598],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7751,
    combinedAdjustedNetIncomeMaximum: 7800.99,
    amounts: [1287, 1831, 2122, 2370, 2607],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7801,
    combinedAdjustedNetIncomeMaximum: 7850.99,
    amounts: [1292, 1838, 2130, 2379, 2617],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7851,
    combinedAdjustedNetIncomeMaximum: 7900.99,
    amounts: [1297, 1845, 2138, 2388, 2627],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7901,
    combinedAdjustedNetIncomeMaximum: 7950.99,
    amounts: [1302, 1852, 2145, 2396, 2636],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7951,
    combinedAdjustedNetIncomeMaximum: 8000.99,
    amounts: [1307, 1859, 2153, 2405, 2646],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8001,
    combinedAdjustedNetIncomeMaximum: 8050.99,
    amounts: [1312, 1866, 2161, 2414, 2655],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8051,
    combinedAdjustedNetIncomeMaximum: 8100.99,
    amounts: [1317, 1873, 2169, 2422, 2665],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8101,
    combinedAdjustedNetIncomeMaximum: 8150.99,
    amounts: [1322, 1880, 2176, 2431, 2674],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8151,
    combinedAdjustedNetIncomeMaximum: 8200.99,
    amounts: [1327, 1887, 2184, 2440, 2684],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8201,
    combinedAdjustedNetIncomeMaximum: 8250.99,
    amounts: [1332, 1894, 2192, 2448, 2693],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8251,
    combinedAdjustedNetIncomeMaximum: 8300.99,
    amounts: [1337, 1901, 2200, 2457, 2703],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8301,
    combinedAdjustedNetIncomeMaximum: 8350.99,
    amounts: [1342, 1908, 2208, 2466, 2713],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8351,
    combinedAdjustedNetIncomeMaximum: 8400.99,
    amounts: [1347, 1915, 2217, 2476, 2724],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8401,
    combinedAdjustedNetIncomeMaximum: 8450.99,
    amounts: [1352, 1923, 2225, 2486, 2734],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8451,
    combinedAdjustedNetIncomeMaximum: 8500.99,
    amounts: [1357, 1930, 2234, 2496, 2745],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8501,
    combinedAdjustedNetIncomeMaximum: 8550.99,
    amounts: [1362, 1937, 2243, 2505, 2756],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8551,
    combinedAdjustedNetIncomeMaximum: 8600.99,
    amounts: [1367, 1945, 2252, 2515, 2767],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8601,
    combinedAdjustedNetIncomeMaximum: 8650.99,
    amounts: [1372, 1952, 2260, 2525, 2777],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8651,
    combinedAdjustedNetIncomeMaximum: 8700.99,
    amounts: [1378, 1959, 2269, 2535, 2788],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8701,
    combinedAdjustedNetIncomeMaximum: 8750.99,
    amounts: [1383, 1967, 2278, 2544, 2799],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8751,
    combinedAdjustedNetIncomeMaximum: 8800.99,
    amounts: [1388, 1974, 2287, 2554, 2810],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8801,
    combinedAdjustedNetIncomeMaximum: 8850.99,
    amounts: [1393, 1982, 2295, 2564, 2820],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8851,
    combinedAdjustedNetIncomeMaximum: 8900.99,
    amounts: [1398, 1989, 2304, 2574, 2831],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8901,
    combinedAdjustedNetIncomeMaximum: 8950.99,
    amounts: [1403, 1996, 2313, 2584, 2842],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8951,
    combinedAdjustedNetIncomeMaximum: 9000.99,
    amounts: [1408, 2004, 2322, 2593, 2853],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9001,
    combinedAdjustedNetIncomeMaximum: 9050.99,
    amounts: [1413, 2011, 2331, 2603, 2863],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9051,
    combinedAdjustedNetIncomeMaximum: 9100.99,
    amounts: [1418, 2019, 2339, 2613, 2874],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9101,
    combinedAdjustedNetIncomeMaximum: 9150.99,
    amounts: [1423, 2026, 2348, 2623, 2885],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9151,
    combinedAdjustedNetIncomeMaximum: 9200.99,
    amounts: [1428, 2033, 2357, 2633, 2896],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9201,
    combinedAdjustedNetIncomeMaximum: 9250.99,
    amounts: [1434, 2041, 2366, 2642, 2907],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9251,
    combinedAdjustedNetIncomeMaximum: 9300.99,
    amounts: [1439, 2048, 2374, 2652, 2917],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9301,
    combinedAdjustedNetIncomeMaximum: 9350.99,
    amounts: [1442, 2052, 2379, 2657, 2923],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9351,
    combinedAdjustedNetIncomeMaximum: 9400.99,
    amounts: [1444, 2056, 2383, 2662, 2928],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9401,
    combinedAdjustedNetIncomeMaximum: 9450.99,
    amounts: [1447, 2059, 2387, 2666, 2933],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9451,
    combinedAdjustedNetIncomeMaximum: 9500.99,
    amounts: [1449, 2063, 2391, 2671, 2938],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9501,
    combinedAdjustedNetIncomeMaximum: 9550.99,
    amounts: [1452, 2067, 2395, 2675, 2943],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9551,
    combinedAdjustedNetIncomeMaximum: 9600.99,
    amounts: [1454, 2070, 2399, 2680, 2948],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9601,
    combinedAdjustedNetIncomeMaximum: 9650.99,
    amounts: [1457, 2074, 2403, 2684, 2953],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9651,
    combinedAdjustedNetIncomeMaximum: 9700.99,
    amounts: [1460, 2077, 2407, 2689, 2958],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9701,
    combinedAdjustedNetIncomeMaximum: 9750.99,
    amounts: [1462, 2081, 2411, 2693, 2963],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9751,
    combinedAdjustedNetIncomeMaximum: 9800.99,
    amounts: [1465, 2085, 2415, 2698, 2968],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9801,
    combinedAdjustedNetIncomeMaximum: 9850.99,
    amounts: [1467, 2088, 2419, 2702, 2972],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9851,
    combinedAdjustedNetIncomeMaximum: 9900.99,
    amounts: [1470, 2092, 2423, 2707, 2977],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9901,
    combinedAdjustedNetIncomeMaximum: 9950.99,
    amounts: [1473, 2095, 2427, 2711, 2982],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9951,
    combinedAdjustedNetIncomeMaximum: 10000.99,
    amounts: [1475, 2099, 2431, 2716, 2987],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10001,
    combinedAdjustedNetIncomeMaximum: 10050.99,
    amounts: [1478, 2103, 2435, 2720, 2992],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10051,
    combinedAdjustedNetIncomeMaximum: 10100.99,
    amounts: [1480, 2106, 2439, 2725, 2997],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10101,
    combinedAdjustedNetIncomeMaximum: 10150.99,
    amounts: [1483, 2110, 2443, 2729, 3002],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10151,
    combinedAdjustedNetIncomeMaximum: 10200.99,
    amounts: [1486, 2113, 2447, 2734, 3007],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10201,
    combinedAdjustedNetIncomeMaximum: 10250.99,
    amounts: [1488, 2117, 2451, 2738, 3012],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10251,
    combinedAdjustedNetIncomeMaximum: 10300.99,
    amounts: [1491, 2121, 2456, 2744, 3018],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10301,
    combinedAdjustedNetIncomeMaximum: 10350.99,
    amounts: [1496, 2127, 2463, 2751, 3026],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10351,
    combinedAdjustedNetIncomeMaximum: 10400.99,
    amounts: [1500, 2133, 2469, 2758, 3034],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10401,
    combinedAdjustedNetIncomeMaximum: 10450.99,
    amounts: [1504, 2139, 2476, 2765, 3042],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10451,
    combinedAdjustedNetIncomeMaximum: 10500.99,
    amounts: [1508, 2144, 2482, 2772, 3050],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10501,
    combinedAdjustedNetIncomeMaximum: 10550.99,
    amounts: [1513, 2150, 2488, 2780, 3057],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10551,
    combinedAdjustedNetIncomeMaximum: 10600.99,
    amounts: [1517, 2156, 2495, 2787, 3065],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10601,
    combinedAdjustedNetIncomeMaximum: 10650.99,
    amounts: [1521, 2162, 2501, 2794, 3073],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10651,
    combinedAdjustedNetIncomeMaximum: 10700.99,
    amounts: [1526, 2168, 2508, 2801, 3081],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10701,
    combinedAdjustedNetIncomeMaximum: 10750.99,
    amounts: [1530, 2173, 2514, 2808, 3089],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10751,
    combinedAdjustedNetIncomeMaximum: 10800.99,
    amounts: [1534, 2179, 2521, 2816, 3097],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10801,
    combinedAdjustedNetIncomeMaximum: 10850.99,
    amounts: [1538, 2185, 2527, 2823, 3105],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10851,
    combinedAdjustedNetIncomeMaximum: 10900.99,
    amounts: [1543, 2191, 2533, 2830, 3113],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10901,
    combinedAdjustedNetIncomeMaximum: 10950.99,
    amounts: [1547, 2197, 2540, 2837, 3121],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10951,
    combinedAdjustedNetIncomeMaximum: 11000.99,
    amounts: [1551, 2202, 2546, 2844, 3129],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11001,
    combinedAdjustedNetIncomeMaximum: 11050.99,
    amounts: [1556, 2208, 2553, 2851, 3137],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11051,
    combinedAdjustedNetIncomeMaximum: 11100.99,
    amounts: [1560, 2214, 2559, 2859, 3145],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11101,
    combinedAdjustedNetIncomeMaximum: 11150.99,
    amounts: [1564, 2220, 2566, 2866, 3152],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11151,
    combinedAdjustedNetIncomeMaximum: 11200.99,
    amounts: [1569, 2226, 2572, 2873, 3160],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11201,
    combinedAdjustedNetIncomeMaximum: 11250.99,
    amounts: [1573, 2232, 2579, 2880, 3168],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11251,
    combinedAdjustedNetIncomeMaximum: 11300.99,
    amounts: [1577, 2237, 2585, 2887, 3176],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11301,
    combinedAdjustedNetIncomeMaximum: 11350.99,
    amounts: [1581, 2243, 2591, 2895, 3184],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11351,
    combinedAdjustedNetIncomeMaximum: 11400.99,
    amounts: [1586, 2249, 2598, 2902, 3192],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11401,
    combinedAdjustedNetIncomeMaximum: 11450.99,
    amounts: [1590, 2255, 2604, 2909, 3200],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11451,
    combinedAdjustedNetIncomeMaximum: 11500.99,
    amounts: [1594, 2261, 2611, 2916, 3208],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11501,
    combinedAdjustedNetIncomeMaximum: 11550.99,
    amounts: [1599, 2267, 2618, 2925, 3217],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11551,
    combinedAdjustedNetIncomeMaximum: 11600.99,
    amounts: [1604, 2274, 2626, 2933, 3227],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11601,
    combinedAdjustedNetIncomeMaximum: 11650.99,
    amounts: [1608, 2281, 2634, 2942, 3236],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11651,
    combinedAdjustedNetIncomeMaximum: 11700.99,
    amounts: [1613, 2287, 2642, 2951, 3246],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11701,
    combinedAdjustedNetIncomeMaximum: 11750.99,
    amounts: [1618, 2294, 2650, 2960, 3256],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11751,
    combinedAdjustedNetIncomeMaximum: 11800.99,
    amounts: [1623, 2301, 2657, 2968, 3265],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11801,
    combinedAdjustedNetIncomeMaximum: 11850.99,
    amounts: [1627, 2308, 2665, 2977, 3275],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11851,
    combinedAdjustedNetIncomeMaximum: 11900.99,
    amounts: [1632, 2314, 2673, 2986, 3284],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11901,
    combinedAdjustedNetIncomeMaximum: 11950.99,
    amounts: [1637, 2321, 2681, 2995, 3294],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11951,
    combinedAdjustedNetIncomeMaximum: 12000.99,
    amounts: [1642, 2328, 2689, 3003, 3304],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12001,
    combinedAdjustedNetIncomeMaximum: 12050.99,
    amounts: [1646, 2335, 2696, 3012, 3313],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12051,
    combinedAdjustedNetIncomeMaximum: 12100.99,
    amounts: [1651, 2341, 2704, 3021, 3323],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12101,
    combinedAdjustedNetIncomeMaximum: 12150.99,
    amounts: [1656, 2348, 2712, 3029, 3332],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12151,
    combinedAdjustedNetIncomeMaximum: 12200.99,
    amounts: [1661, 2355, 2720, 3038, 3342],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12201,
    combinedAdjustedNetIncomeMaximum: 12250.99,
    amounts: [1665, 2362, 2728, 3047, 3352],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12251,
    combinedAdjustedNetIncomeMaximum: 12300.99,
    amounts: [1670, 2368, 2735, 3056, 3361],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12301,
    combinedAdjustedNetIncomeMaximum: 12350.99,
    amounts: [1675, 2375, 2743, 3064, 3371],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12351,
    combinedAdjustedNetIncomeMaximum: 12400.99,
    amounts: [1680, 2382, 2751, 3073, 3380],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12401,
    combinedAdjustedNetIncomeMaximum: 12450.99,
    amounts: [1684, 2389, 2759, 3082, 3390],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12451,
    combinedAdjustedNetIncomeMaximum: 12500.99,
    amounts: [1689, 2395, 2767, 3090, 3399],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12501,
    combinedAdjustedNetIncomeMaximum: 12550.99,
    amounts: [1694, 2402, 2775, 3099, 3409],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12551,
    combinedAdjustedNetIncomeMaximum: 12600.99,
    amounts: [1699, 2409, 2782, 3108, 3419],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12601,
    combinedAdjustedNetIncomeMaximum: 12650.99,
    amounts: [1703, 2416, 2790, 3117, 3428],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12651,
    combinedAdjustedNetIncomeMaximum: 12700.99,
    amounts: [1708, 2422, 2798, 3125, 3438],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12701,
    combinedAdjustedNetIncomeMaximum: 12750.99,
    amounts: [1713, 2429, 2806, 3134, 3447],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12751,
    combinedAdjustedNetIncomeMaximum: 12800.99,
    amounts: [1718, 2436, 2814, 3143, 3457],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12801,
    combinedAdjustedNetIncomeMaximum: 12850.99,
    amounts: [1722, 2443, 2821, 3151, 3467],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12851,
    combinedAdjustedNetIncomeMaximum: 12900.99,
    amounts: [1727, 2450, 2829, 3160, 3476],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12901,
    combinedAdjustedNetIncomeMaximum: 12950.99,
    amounts: [1732, 2456, 2837, 3169, 3486],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12951,
    combinedAdjustedNetIncomeMaximum: 13000.99,
    amounts: [1737, 2463, 2845, 3178, 3495],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13001,
    combinedAdjustedNetIncomeMaximum: 13050.99,
    amounts: [1741, 2470, 2853, 3186, 3505],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13051,
    combinedAdjustedNetIncomeMaximum: 13100.99,
    amounts: [1746, 2477, 2860, 3195, 3515],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13101,
    combinedAdjustedNetIncomeMaximum: 13150.99,
    amounts: [1751, 2483, 2868, 3204, 3524],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13151,
    combinedAdjustedNetIncomeMaximum: 13200.99,
    amounts: [1756, 2490, 2876, 3212, 3534],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13201,
    combinedAdjustedNetIncomeMaximum: 13250.99,
    amounts: [1760, 2497, 2884, 3221, 3543],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13251,
    combinedAdjustedNetIncomeMaximum: 13300.99,
    amounts: [1765, 2504, 2892, 3230, 3553],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13301,
    combinedAdjustedNetIncomeMaximum: 13350.99,
    amounts: [1770, 2510, 2899, 3239, 3563],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13351,
    combinedAdjustedNetIncomeMaximum: 13400.99,
    amounts: [1775, 2517, 2907, 3247, 3572],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13401,
    combinedAdjustedNetIncomeMaximum: 13450.99,
    amounts: [1779, 2524, 2915, 3256, 3582],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13451,
    combinedAdjustedNetIncomeMaximum: 13500.99,
    amounts: [1783, 2529, 2921, 3263, 3589],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13501,
    combinedAdjustedNetIncomeMaximum: 13550.99,
    amounts: [1787, 2534, 2926, 3269, 3596],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13551,
    combinedAdjustedNetIncomeMaximum: 13600.99,
    amounts: [1790, 2539, 2932, 3275, 3603],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13601,
    combinedAdjustedNetIncomeMaximum: 13650.99,
    amounts: [1794, 2544, 2937, 3281, 3609],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13651,
    combinedAdjustedNetIncomeMaximum: 13700.99,
    amounts: [1797, 2549, 2943, 3287, 3616],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13701,
    combinedAdjustedNetIncomeMaximum: 13750.99,
    amounts: [1801, 2554, 2949, 3293, 3623],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13751,
    combinedAdjustedNetIncomeMaximum: 13800.99,
    amounts: [1804, 2558, 2954, 3300, 3630],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13801,
    combinedAdjustedNetIncomeMaximum: 13850.99,
    amounts: [1808, 2563, 2960, 3306, 3636],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13851,
    combinedAdjustedNetIncomeMaximum: 13900.99,
    amounts: [1812, 2568, 2965, 3312, 3643],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13901,
    combinedAdjustedNetIncomeMaximum: 13950.99,
    amounts: [1815, 2573, 2971, 3318, 3650],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13951,
    combinedAdjustedNetIncomeMaximum: 14000.99,
    amounts: [1819, 2578, 2976, 3324, 3657],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14001,
    combinedAdjustedNetIncomeMaximum: 14050.99,
    amounts: [1822, 2583, 2982, 3330, 3663],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14051,
    combinedAdjustedNetIncomeMaximum: 14100.99,
    amounts: [1826, 2588, 2987, 3337, 3670],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14101,
    combinedAdjustedNetIncomeMaximum: 14150.99,
    amounts: [1829, 2593, 2993, 3343, 3677],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14151,
    combinedAdjustedNetIncomeMaximum: 14200.99,
    amounts: [1833, 2598, 2998, 3349, 3684],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14201,
    combinedAdjustedNetIncomeMaximum: 14250.99,
    amounts: [1836, 2603, 3004, 3355, 3691],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14251,
    combinedAdjustedNetIncomeMaximum: 14300.99,
    amounts: [1840, 2608, 3009, 3361, 3697],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14301,
    combinedAdjustedNetIncomeMaximum: 14350.99,
    amounts: [1844, 2612, 3015, 3367, 3704],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14351,
    combinedAdjustedNetIncomeMaximum: 14400.99,
    amounts: [1847, 2617, 3020, 3374, 3711],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14401,
    combinedAdjustedNetIncomeMaximum: 14450.99,
    amounts: [1851, 2622, 3026, 3380, 3718],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14451,
    combinedAdjustedNetIncomeMaximum: 14500.99,
    amounts: [1854, 2627, 3031, 3386, 3724],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14501,
    combinedAdjustedNetIncomeMaximum: 14550.99,
    amounts: [1858, 2632, 3037, 3392, 3731],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14551,
    combinedAdjustedNetIncomeMaximum: 14600.99,
    amounts: [1861, 2637, 3042, 3398, 3738],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14601,
    combinedAdjustedNetIncomeMaximum: 14650.99,
    amounts: [1865, 2642, 3048, 3404, 3745],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14651,
    combinedAdjustedNetIncomeMaximum: 14700.99,
    amounts: [1868, 2647, 3053, 3410, 3752],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14701,
    combinedAdjustedNetIncomeMaximum: 14750.99,
    amounts: [1872, 2652, 3059, 3417, 3758],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14751,
    combinedAdjustedNetIncomeMaximum: 14800.99,
    amounts: [1876, 2657, 3064, 3423, 3765],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14801,
    combinedAdjustedNetIncomeMaximum: 14850.99,
    amounts: [1879, 2661, 3070, 3429, 3772],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14851,
    combinedAdjustedNetIncomeMaximum: 14900.99,
    amounts: [1883, 2666, 3075, 3435, 3779],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14901,
    combinedAdjustedNetIncomeMaximum: 14950.99,
    amounts: [1886, 2671, 3081, 3441, 3785],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14951,
    combinedAdjustedNetIncomeMaximum: 15000.99,
    amounts: [1890, 2676, 3086, 3447, 3792],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15001,
    combinedAdjustedNetIncomeMaximum: 15050.99,
    amounts: [1893, 2681, 3092, 3454, 3799],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15051,
    combinedAdjustedNetIncomeMaximum: 15100.99,
    amounts: [1897, 2686, 3097, 3460, 3806],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15101,
    combinedAdjustedNetIncomeMaximum: 15150.99,
    amounts: [1900, 2691, 3103, 3466, 3812],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15151,
    combinedAdjustedNetIncomeMaximum: 15200.99,
    amounts: [1904, 2696, 3108, 3472, 3819],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15201,
    combinedAdjustedNetIncomeMaximum: 15250.99,
    amounts: [1907, 2701, 3114, 3478, 3826],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15251,
    combinedAdjustedNetIncomeMaximum: 15300.99,
    amounts: [1911, 2706, 3119, 3484, 3833],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15301,
    combinedAdjustedNetIncomeMaximum: 15350.99,
    amounts: [1915, 2710, 3125, 3491, 3840],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15351,
    combinedAdjustedNetIncomeMaximum: 15400.99,
    amounts: [1918, 2715, 3130, 3497, 3846],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15401,
    combinedAdjustedNetIncomeMaximum: 15450.99,
    amounts: [1922, 2720, 3136, 3503, 3853],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15451,
    combinedAdjustedNetIncomeMaximum: 15500.99,
    amounts: [1925, 2725, 3141, 3509, 3860],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15501,
    combinedAdjustedNetIncomeMaximum: 15550.99,
    amounts: [1929, 2730, 3147, 3515, 3867],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15551,
    combinedAdjustedNetIncomeMaximum: 15600.99,
    amounts: [1932, 2735, 3152, 3521, 3873],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15601,
    combinedAdjustedNetIncomeMaximum: 15650.99,
    amounts: [1936, 2740, 3158, 3527, 3880],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15651,
    combinedAdjustedNetIncomeMaximum: 15700.99,
    amounts: [1939, 2745, 3163, 3534, 3887],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15701,
    combinedAdjustedNetIncomeMaximum: 15750.99,
    amounts: [1943, 2750, 3169, 3540, 3894],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15751,
    combinedAdjustedNetIncomeMaximum: 15800.99,
    amounts: [1947, 2755, 3175, 3546, 3901],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15801,
    combinedAdjustedNetIncomeMaximum: 15850.99,
    amounts: [1950, 2760, 3180, 3552, 3907],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15851,
    combinedAdjustedNetIncomeMaximum: 15900.99,
    amounts: [1954, 2764, 3186, 3558, 3914],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15901,
    combinedAdjustedNetIncomeMaximum: 15950.99,
    amounts: [1957, 2769, 3191, 3564, 3921],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15951,
    combinedAdjustedNetIncomeMaximum: 16000.99,
    amounts: [1961, 2774, 3197, 3571, 3928],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16001,
    combinedAdjustedNetIncomeMaximum: 16050.99,
    amounts: [1964, 2779, 3202, 3577, 3934],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16051,
    combinedAdjustedNetIncomeMaximum: 16100.99,
    amounts: [1968, 2784, 3208, 3583, 3941],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16101,
    combinedAdjustedNetIncomeMaximum: 16150.99,
    amounts: [1971, 2789, 3213, 3589, 3948],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16151,
    combinedAdjustedNetIncomeMaximum: 16200.99,
    amounts: [1975, 2794, 3219, 3595, 3955],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16201,
    combinedAdjustedNetIncomeMaximum: 16250.99,
    amounts: [1978, 2799, 3224, 3601, 3961],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16251,
    combinedAdjustedNetIncomeMaximum: 16300.99,
    amounts: [1982, 2804, 3230, 3607, 3968],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16301,
    combinedAdjustedNetIncomeMaximum: 16350.99,
    amounts: [1986, 2809, 3235, 3614, 3975],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16351,
    combinedAdjustedNetIncomeMaximum: 16400.99,
    amounts: [1989, 2813, 3241, 3620, 3982],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16401,
    combinedAdjustedNetIncomeMaximum: 16450.99,
    amounts: [1993, 2818, 3246, 3626, 3989],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16451,
    combinedAdjustedNetIncomeMaximum: 16500.99,
    amounts: [1996, 2823, 3252, 3632, 3995],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16501,
    combinedAdjustedNetIncomeMaximum: 16550.99,
    amounts: [2000, 2828, 3257, 3638, 4002],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16551,
    combinedAdjustedNetIncomeMaximum: 16600.99,
    amounts: [2003, 2833, 3263, 3644, 4009],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16601,
    combinedAdjustedNetIncomeMaximum: 16650.99,
    amounts: [2007, 2838, 3268, 3651, 4016],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16651,
    combinedAdjustedNetIncomeMaximum: 16700.99,
    amounts: [2010, 2843, 3274, 3657, 4022],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16701,
    combinedAdjustedNetIncomeMaximum: 16750.99,
    amounts: [2014, 2848, 3279, 3663, 4029],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16751,
    combinedAdjustedNetIncomeMaximum: 16800.99,
    amounts: [2018, 2853, 3285, 3669, 4036],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16801,
    combinedAdjustedNetIncomeMaximum: 16850.99,
    amounts: [2021, 2858, 3290, 3675, 4043],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16851,
    combinedAdjustedNetIncomeMaximum: 16900.99,
    amounts: [2025, 2863, 3296, 3681, 4050],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16901,
    combinedAdjustedNetIncomeMaximum: 16950.99,
    amounts: [2028, 2867, 3301, 3688, 4056],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16951,
    combinedAdjustedNetIncomeMaximum: 17000.99,
    amounts: [2032, 2872, 3307, 3694, 4063],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17001,
    combinedAdjustedNetIncomeMaximum: 17050.99,
    amounts: [2035, 2877, 3312, 3700, 4070],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17051,
    combinedAdjustedNetIncomeMaximum: 17100.99,
    amounts: [2039, 2882, 3318, 3706, 4077],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17101,
    combinedAdjustedNetIncomeMaximum: 17150.99,
    amounts: [2042, 2887, 3323, 3712, 4083],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17151,
    combinedAdjustedNetIncomeMaximum: 17200.99,
    amounts: [2046, 2892, 3329, 3718, 4090],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17201,
    combinedAdjustedNetIncomeMaximum: 17250.99,
    amounts: [2050, 2897, 3334, 3724, 4097],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17251,
    combinedAdjustedNetIncomeMaximum: 17300.99,
    amounts: [2053, 2902, 3340, 3731, 4104],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17301,
    combinedAdjustedNetIncomeMaximum: 17350.99,
    amounts: [2057, 2907, 3345, 3737, 4110],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17351,
    combinedAdjustedNetIncomeMaximum: 17400.99,
    amounts: [2060, 2912, 3351, 3743, 4117],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17401,
    combinedAdjustedNetIncomeMaximum: 17450.99,
    amounts: [2064, 2916, 3356, 3749, 4124],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17451,
    combinedAdjustedNetIncomeMaximum: 17500.99,
    amounts: [2067, 2921, 3362, 3755, 4131],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17501,
    combinedAdjustedNetIncomeMaximum: 17550.99,
    amounts: [2071, 2926, 3367, 3761, 4138],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17551,
    combinedAdjustedNetIncomeMaximum: 17600.99,
    amounts: [2074, 2931, 3373, 3768, 4144],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17601,
    combinedAdjustedNetIncomeMaximum: 17650.99,
    amounts: [2078, 2936, 3378, 3774, 4151],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17651,
    combinedAdjustedNetIncomeMaximum: 17700.99,
    amounts: [2081, 2941, 3384, 3780, 4158],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17701,
    combinedAdjustedNetIncomeMaximum: 17750.99,
    amounts: [2085, 2946, 3389, 3786, 4165],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17751,
    combinedAdjustedNetIncomeMaximum: 17800.99,
    amounts: [2089, 2951, 3395, 3792, 4171],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17801,
    combinedAdjustedNetIncomeMaximum: 17850.99,
    amounts: [2092, 2956, 3401, 3798, 4178],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17851,
    combinedAdjustedNetIncomeMaximum: 17900.99,
    amounts: [2096, 2961, 3406, 3805, 4185],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17901,
    combinedAdjustedNetIncomeMaximum: 17950.99,
    amounts: [2099, 2965, 3412, 3811, 4192],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17951,
    combinedAdjustedNetIncomeMaximum: 18000.99,
    amounts: [2103, 2970, 3417, 3817, 4199],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18001,
    combinedAdjustedNetIncomeMaximum: 18050.99,
    amounts: [2106, 2975, 3423, 3823, 4205],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18051,
    combinedAdjustedNetIncomeMaximum: 18100.99,
    amounts: [2110, 2980, 3428, 3829, 4212],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18101,
    combinedAdjustedNetIncomeMaximum: 18150.99,
    amounts: [2113, 2985, 3434, 3835, 4219],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18151,
    combinedAdjustedNetIncomeMaximum: 18200.99,
    amounts: [2117, 2990, 3439, 3841, 4226],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18201,
    combinedAdjustedNetIncomeMaximum: 18250.99,
    amounts: [2121, 2995, 3445, 3848, 4232],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18251,
    combinedAdjustedNetIncomeMaximum: 18300.99,
    amounts: [2124, 3000, 3450, 3854, 4239],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18301,
    combinedAdjustedNetIncomeMaximum: 18350.99,
    amounts: [2128, 3005, 3456, 3860, 4246],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18351,
    combinedAdjustedNetIncomeMaximum: 18400.99,
    amounts: [2131, 3010, 3461, 3866, 4253],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18401,
    combinedAdjustedNetIncomeMaximum: 18450.99,
    amounts: [2135, 3015, 3467, 3872, 4259],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18451,
    combinedAdjustedNetIncomeMaximum: 18500.99,
    amounts: [2138, 3019, 3472, 3878, 4266],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18501,
    combinedAdjustedNetIncomeMaximum: 18550.99,
    amounts: [2142, 3024, 3478, 3885, 4273],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18551,
    combinedAdjustedNetIncomeMaximum: 18600.99,
    amounts: [2145, 3029, 3483, 3891, 4280],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18601,
    combinedAdjustedNetIncomeMaximum: 18650.99,
    amounts: [2149, 3034, 3489, 3897, 4287],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18651,
    combinedAdjustedNetIncomeMaximum: 18700.99,
    amounts: [2153, 3039, 3494, 3903, 4293],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18701,
    combinedAdjustedNetIncomeMaximum: 18750.99,
    amounts: [2156, 3044, 3500, 3909, 4300],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18751,
    combinedAdjustedNetIncomeMaximum: 18800.99,
    amounts: [2160, 3049, 3505, 3915, 4307],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18801,
    combinedAdjustedNetIncomeMaximum: 18850.99,
    amounts: [2163, 3054, 3511, 3922, 4314],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18851,
    combinedAdjustedNetIncomeMaximum: 18900.99,
    amounts: [2167, 3059, 3516, 3928, 4320],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18901,
    combinedAdjustedNetIncomeMaximum: 18950.99,
    amounts: [2170, 3064, 3522, 3934, 4327],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18951,
    combinedAdjustedNetIncomeMaximum: 19000.99,
    amounts: [2174, 3068, 3527, 3940, 4334],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19001,
    combinedAdjustedNetIncomeMaximum: 19050.99,
    amounts: [2177, 3073, 3533, 3946, 4341],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19051,
    combinedAdjustedNetIncomeMaximum: 19100.99,
    amounts: [2181, 3078, 3538, 3952, 4348],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19101,
    combinedAdjustedNetIncomeMaximum: 19150.99,
    amounts: [2184, 3083, 3544, 3958, 4354],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19151,
    combinedAdjustedNetIncomeMaximum: 19200.99,
    amounts: [2188, 3088, 3549, 3965, 4361],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19201,
    combinedAdjustedNetIncomeMaximum: 19250.99,
    amounts: [2192, 3093, 3555, 3971, 4368],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19251,
    combinedAdjustedNetIncomeMaximum: 19300.99,
    amounts: [2195, 3098, 3560, 3977, 4375],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19301,
    combinedAdjustedNetIncomeMaximum: 19350.99,
    amounts: [2199, 3103, 3566, 3983, 4381],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19351,
    combinedAdjustedNetIncomeMaximum: 19400.99,
    amounts: [2202, 3108, 3571, 3989, 4388],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19401,
    combinedAdjustedNetIncomeMaximum: 19450.99,
    amounts: [2206, 3113, 3577, 3995, 4395],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19451,
    combinedAdjustedNetIncomeMaximum: 19500.99,
    amounts: [2209, 3118, 3582, 4002, 4402],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19501,
    combinedAdjustedNetIncomeMaximum: 19550.99,
    amounts: [2213, 3122, 3588, 4008, 4408],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19551,
    combinedAdjustedNetIncomeMaximum: 19600.99,
    amounts: [2216, 3127, 3593, 4014, 4415],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19601,
    combinedAdjustedNetIncomeMaximum: 19650.99,
    amounts: [2220, 3132, 3599, 4020, 4422],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19651,
    combinedAdjustedNetIncomeMaximum: 19700.99,
    amounts: [2224, 3137, 3604, 4026, 4429],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19701,
    combinedAdjustedNetIncomeMaximum: 19750.99,
    amounts: [2227, 3142, 3610, 4032, 4436],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19751,
    combinedAdjustedNetIncomeMaximum: 19800.99,
    amounts: [2231, 3147, 3615, 4038, 4442],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19801,
    combinedAdjustedNetIncomeMaximum: 19850.99,
    amounts: [2234, 3152, 3621, 4045, 4449],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19851,
    combinedAdjustedNetIncomeMaximum: 19900.99,
    amounts: [2238, 3157, 3626, 4051, 4456],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19901,
    combinedAdjustedNetIncomeMaximum: 19950.99,
    amounts: [2241, 3162, 3632, 4057, 4463],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19951,
    combinedAdjustedNetIncomeMaximum: 20000.99,
    amounts: [2245, 3167, 3638, 4063, 4469],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20001,
    combinedAdjustedNetIncomeMaximum: 20050.99,
    amounts: [2248, 3171, 3643, 4069, 4476],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20051,
    combinedAdjustedNetIncomeMaximum: 20100.99,
    amounts: [2252, 3176, 3649, 4075, 4483],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20101,
    combinedAdjustedNetIncomeMaximum: 20150.99,
    amounts: [2256, 3181, 3654, 4082, 4490],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20151,
    combinedAdjustedNetIncomeMaximum: 20200.99,
    amounts: [2259, 3186, 3660, 4088, 4497],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20201,
    combinedAdjustedNetIncomeMaximum: 20250.99,
    amounts: [2263, 3191, 3665, 4094, 4503],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20251,
    combinedAdjustedNetIncomeMaximum: 20300.99,
    amounts: [2266, 3196, 3671, 4100, 4510],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20301,
    combinedAdjustedNetIncomeMaximum: 20350.99,
    amounts: [2270, 3201, 3676, 4106, 4517],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20351,
    combinedAdjustedNetIncomeMaximum: 20400.99,
    amounts: [2273, 3206, 3682, 4112, 4524],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20401,
    combinedAdjustedNetIncomeMaximum: 20450.99,
    amounts: [2277, 3211, 3687, 4119, 4530],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20451,
    combinedAdjustedNetIncomeMaximum: 20500.99,
    amounts: [2280, 3216, 3693, 4125, 4537],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20501,
    combinedAdjustedNetIncomeMaximum: 20550.99,
    amounts: [2284, 3220, 3698, 4131, 4544],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20551,
    combinedAdjustedNetIncomeMaximum: 20600.99,
    amounts: [2287, 3225, 3704, 4137, 4551],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20601,
    combinedAdjustedNetIncomeMaximum: 20650.99,
    amounts: [2291, 3230, 3709, 4143, 4557],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20651,
    combinedAdjustedNetIncomeMaximum: 20700.99,
    amounts: [2295, 3235, 3715, 4149, 4564],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20701,
    combinedAdjustedNetIncomeMaximum: 20750.99,
    amounts: [2298, 3240, 3720, 4155, 4571],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20751,
    combinedAdjustedNetIncomeMaximum: 20800.99,
    amounts: [2302, 3245, 3726, 4162, 4578],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20801,
    combinedAdjustedNetIncomeMaximum: 20850.99,
    amounts: [2305, 3250, 3731, 4168, 4585],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20851,
    combinedAdjustedNetIncomeMaximum: 20900.99,
    amounts: [2309, 3255, 3737, 4174, 4591],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20901,
    combinedAdjustedNetIncomeMaximum: 20950.99,
    amounts: [2312, 3260, 3742, 4180, 4598],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20951,
    combinedAdjustedNetIncomeMaximum: 21000.99,
    amounts: [2316, 3265, 3748, 4186, 4605],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21001,
    combinedAdjustedNetIncomeMaximum: 21050.99,
    amounts: [2319, 3270, 3753, 4192, 4612],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21051,
    combinedAdjustedNetIncomeMaximum: 21100.99,
    amounts: [2323, 3274, 3759, 4199, 4618],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21101,
    combinedAdjustedNetIncomeMaximum: 21150.99,
    amounts: [2327, 3279, 3764, 4205, 4625],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21151,
    combinedAdjustedNetIncomeMaximum: 21200.99,
    amounts: [2330, 3284, 3770, 4211, 4632],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21201,
    combinedAdjustedNetIncomeMaximum: 21250.99,
    amounts: [2334, 3289, 3775, 4217, 4639],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21251,
    combinedAdjustedNetIncomeMaximum: 21300.99,
    amounts: [2337, 3294, 3781, 4223, 4646],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21301,
    combinedAdjustedNetIncomeMaximum: 21350.99,
    amounts: [2341, 3299, 3786, 4229, 4652],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21351,
    combinedAdjustedNetIncomeMaximum: 21400.99,
    amounts: [2344, 3304, 3792, 4236, 4659],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21401,
    combinedAdjustedNetIncomeMaximum: 21450.99,
    amounts: [2348, 3309, 3797, 4242, 4666],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21451,
    combinedAdjustedNetIncomeMaximum: 21500.99,
    amounts: [2351, 3314, 3803, 4248, 4673],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21501,
    combinedAdjustedNetIncomeMaximum: 21550.99,
    amounts: [2355, 3319, 3808, 4254, 4679],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21551,
    combinedAdjustedNetIncomeMaximum: 21600.99,
    amounts: [2359, 3323, 3814, 4260, 4686],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21601,
    combinedAdjustedNetIncomeMaximum: 21650.99,
    amounts: [2362, 3328, 3819, 4266, 4693],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21651,
    combinedAdjustedNetIncomeMaximum: 21700.99,
    amounts: [2366, 3333, 3825, 4272, 4700],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21701,
    combinedAdjustedNetIncomeMaximum: 21750.99,
    amounts: [2369, 3338, 3830, 4279, 4706],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21751,
    combinedAdjustedNetIncomeMaximum: 21800.99,
    amounts: [2373, 3343, 3836, 4285, 4713],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21801,
    combinedAdjustedNetIncomeMaximum: 21850.99,
    amounts: [2376, 3348, 3841, 4291, 4720],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21851,
    combinedAdjustedNetIncomeMaximum: 21900.99,
    amounts: [2380, 3352, 3846, 4296, 4725],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21901,
    combinedAdjustedNetIncomeMaximum: 21950.99,
    amounts: [2383, 3357, 3850, 4300, 4729],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21951,
    combinedAdjustedNetIncomeMaximum: 22000.99,
    amounts: [2387, 3361, 3855, 4304, 4734],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22001,
    combinedAdjustedNetIncomeMaximum: 22050.99,
    amounts: [2390, 3366, 3859, 4309, 4738],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22051,
    combinedAdjustedNetIncomeMaximum: 22100.99,
    amounts: [2394, 3370, 3863, 4313, 4742],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22101,
    combinedAdjustedNetIncomeMaximum: 22150.99,
    amounts: [2397, 3374, 3867, 4317, 4747],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22151,
    combinedAdjustedNetIncomeMaximum: 22200.99,
    amounts: [2401, 3379, 3872, 4321, 4751],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22201,
    combinedAdjustedNetIncomeMaximum: 22250.99,
    amounts: [2404, 3383, 3876, 4326, 4755],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22251,
    combinedAdjustedNetIncomeMaximum: 22300.99,
    amounts: [2408, 3388, 3880, 4330, 4760],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22301,
    combinedAdjustedNetIncomeMaximum: 22350.99,
    amounts: [2412, 3392, 3884, 4334, 4764],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22351,
    combinedAdjustedNetIncomeMaximum: 22400.99,
    amounts: [2415, 3396, 3889, 4339, 4768],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22401,
    combinedAdjustedNetIncomeMaximum: 22450.99,
    amounts: [2419, 3401, 3893, 4343, 4773],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22451,
    combinedAdjustedNetIncomeMaximum: 22500.99,
    amounts: [2422, 3405, 3897, 4347, 4777],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22501,
    combinedAdjustedNetIncomeMaximum: 22550.99,
    amounts: [2426, 3409, 3902, 4352, 4781],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22551,
    combinedAdjustedNetIncomeMaximum: 22600.99,
    amounts: [2429, 3414, 3906, 4356, 4786],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22601,
    combinedAdjustedNetIncomeMaximum: 22650.99,
    amounts: [2433, 3418, 3910, 4360, 4790],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22651,
    combinedAdjustedNetIncomeMaximum: 22700.99,
    amounts: [2436, 3423, 3914, 4364, 4794],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22701,
    combinedAdjustedNetIncomeMaximum: 22750.99,
    amounts: [2440, 3427, 3919, 4369, 4799],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22751,
    combinedAdjustedNetIncomeMaximum: 22800.99,
    amounts: [2443, 3431, 3923, 4373, 4803],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22801,
    combinedAdjustedNetIncomeMaximum: 22850.99,
    amounts: [2447, 3436, 3927, 4377, 4807],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22851,
    combinedAdjustedNetIncomeMaximum: 22900.99,
    amounts: [2450, 3440, 3931, 4382, 4811],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22901,
    combinedAdjustedNetIncomeMaximum: 22950.99,
    amounts: [2454, 3445, 3936, 4386, 4816],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22951,
    combinedAdjustedNetIncomeMaximum: 23000.99,
    amounts: [2457, 3449, 3940, 4390, 4820],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23001,
    combinedAdjustedNetIncomeMaximum: 23050.99,
    amounts: [2461, 3453, 3944, 4395, 4824],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23051,
    combinedAdjustedNetIncomeMaximum: 23100.99,
    amounts: [2464, 3458, 3949, 4399, 4829],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23101,
    combinedAdjustedNetIncomeMaximum: 23150.99,
    amounts: [2468, 3462, 3953, 4403, 4833],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23151,
    combinedAdjustedNetIncomeMaximum: 23200.99,
    amounts: [2471, 3466, 3957, 4407, 4837],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23201,
    combinedAdjustedNetIncomeMaximum: 23250.99,
    amounts: [2475, 3471, 3961, 4412, 4842],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23251,
    combinedAdjustedNetIncomeMaximum: 23300.99,
    amounts: [2478, 3475, 3966, 4416, 4846],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23301,
    combinedAdjustedNetIncomeMaximum: 23350.99,
    amounts: [2482, 3480, 3970, 4420, 4850],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23351,
    combinedAdjustedNetIncomeMaximum: 23400.99,
    amounts: [2485, 3484, 3974, 4425, 4855],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23401,
    combinedAdjustedNetIncomeMaximum: 23450.99,
    amounts: [2489, 3488, 3978, 4429, 4859],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23451,
    combinedAdjustedNetIncomeMaximum: 23500.99,
    amounts: [2493, 3493, 3983, 4433, 4863],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23501,
    combinedAdjustedNetIncomeMaximum: 23550.99,
    amounts: [2496, 3497, 3987, 4438, 4868],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23551,
    combinedAdjustedNetIncomeMaximum: 23600.99,
    amounts: [2500, 3502, 3991, 4442, 4872],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23601,
    combinedAdjustedNetIncomeMaximum: 23650.99,
    amounts: [2503, 3506, 3996, 4446, 4876],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23651,
    combinedAdjustedNetIncomeMaximum: 23700.99,
    amounts: [2507, 3510, 4000, 4450, 4881],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23701,
    combinedAdjustedNetIncomeMaximum: 23750.99,
    amounts: [2510, 3515, 4004, 4455, 4885],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23751,
    combinedAdjustedNetIncomeMaximum: 23800.99,
    amounts: [2514, 3519, 4008, 4459, 4889],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23801,
    combinedAdjustedNetIncomeMaximum: 23850.99,
    amounts: [2517, 3523, 4013, 4463, 4894],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23851,
    combinedAdjustedNetIncomeMaximum: 23900.99,
    amounts: [2521, 3528, 4017, 4468, 4898],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23901,
    combinedAdjustedNetIncomeMaximum: 23950.99,
    amounts: [2524, 3532, 4021, 4472, 4902],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23951,
    combinedAdjustedNetIncomeMaximum: 24000.99,
    amounts: [2528, 3537, 4025, 4476, 4907],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24001,
    combinedAdjustedNetIncomeMaximum: 24050.99,
    amounts: [2531, 3541, 4030, 4480, 4911],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24051,
    combinedAdjustedNetIncomeMaximum: 24100.99,
    amounts: [2535, 3545, 4034, 4485, 4915],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24101,
    combinedAdjustedNetIncomeMaximum: 24150.99,
    amounts: [2538, 3550, 4038, 4489, 4920],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24151,
    combinedAdjustedNetIncomeMaximum: 24200.99,
    amounts: [2542, 3554, 4043, 4493, 4924],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24201,
    combinedAdjustedNetIncomeMaximum: 24250.99,
    amounts: [2545, 3558, 4047, 4498, 4928],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24251,
    combinedAdjustedNetIncomeMaximum: 24300.99,
    amounts: [2549, 3563, 4051, 4502, 4933],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24301,
    combinedAdjustedNetIncomeMaximum: 24350.99,
    amounts: [2552, 3567, 4055, 4506, 4937],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24351,
    combinedAdjustedNetIncomeMaximum: 24400.99,
    amounts: [2556, 3572, 4060, 4511, 4941],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24401,
    combinedAdjustedNetIncomeMaximum: 24450.99,
    amounts: [2559, 3576, 4064, 4515, 4946],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24451,
    combinedAdjustedNetIncomeMaximum: 24500.99,
    amounts: [2563, 3580, 4068, 4519, 4950],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24501,
    combinedAdjustedNetIncomeMaximum: 24550.99,
    amounts: [2567, 3585, 4072, 4523, 4954],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24551,
    combinedAdjustedNetIncomeMaximum: 24600.99,
    amounts: [2570, 3589, 4077, 4528, 4959],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24601,
    combinedAdjustedNetIncomeMaximum: 24650.99,
    amounts: [2574, 3594, 4081, 4532, 4963],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24651,
    combinedAdjustedNetIncomeMaximum: 24700.99,
    amounts: [2577, 3598, 4085, 4536, 4967],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24701,
    combinedAdjustedNetIncomeMaximum: 24750.99,
    amounts: [2581, 3602, 4090, 4541, 4972],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24751,
    combinedAdjustedNetIncomeMaximum: 24800.99,
    amounts: [2584, 3607, 4094, 4545, 4976],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24801,
    combinedAdjustedNetIncomeMaximum: 24850.99,
    amounts: [2588, 3611, 4098, 4549, 4980],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24851,
    combinedAdjustedNetIncomeMaximum: 24900.99,
    amounts: [2591, 3615, 4102, 4554, 4985],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24901,
    combinedAdjustedNetIncomeMaximum: 24950.99,
    amounts: [2595, 3620, 4107, 4558, 4989],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24951,
    combinedAdjustedNetIncomeMaximum: 25000.99,
    amounts: [2598, 3624, 4111, 4562, 4993],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  }
];
